<template>
    <div class="fileinfo">
        <van-nav-bar :title="$route.query.name" @click-left="onClickLeft" left-arrow />
        <div v-show="pdfShow" id="PDFIframe2" class="PDFIframe" style="height:100vh;overflow: auto;"></div>
        <van-image style="width:100%;" v-show="imgShow" :src="imgUrl" @click="handClickIMG" />
        <video v-show="videoShow" controls :src="videoUrl" style="width:100%;height:95%"></video>
        <div v-html="txtContent" v-show="textShow">{{ info.prfl07 }}</div>
        <div class="questionClass" v-show="questionShow" @click="goQuestion">
            <van-icon name="records" size="30" color="#fff" />
            <div style="color:#fff">问题反馈</div>
        </div>
        <div id="MyViewerDiv" v-show="ViewShow"></div>
    </div>
</template>
<script>
import Pdfh5 from "pdfh5";
import { Office2Pdf } from "@/api/index";
import { ImagePreview } from "vant";
import { GetYWProUserAuth } from "@/api/index";
export default {
    name: "fileinfo",
    data() {
        return {
            pdfh5: null,
            imgShow: false,
            pdfShow: false,
            videoShow: false,
            imgUrl: null,
            videoUrl: null,
            info: {},
            type: null,
            questionShow: true,
            txtContent: null,
            textShow: false,
            ViewShow: false,
        }
    },
    methods: {
        pathUrl() {
            if (this.$route.query.name.includes('png') ||
                this.$route.query.name.includes('jpg') ||
                this.$route.query.name.includes('jpg') ||
                this.$route.query.name.includes('gif')) {
                this.imgUrl = this.$store.state.baseUrl + this.$route.query.item.fpath;
                this.imgShow = true;
            } else if (this.$route.query.name.includes('txt')) {
                const url = this.$store.state.baseUrl + this.$route.query.item.fpath;
                fetch(url).then(response => response.text())
                    .then(text => {
                        // 转换编码，假设文件不是UTF-8编码，而是GBK编码
                        // const convertedText = new TextEncoder().encode(text);
                        // const blob = new Blob([convertedText], { type: 'charset=utf-8' });
                        // const urls = URL.createObjectURL(blob);
                        // 使用转换后的URL设置iframe的src属性
                        // this.iframeUrl = url;
                        this.txtContent = text;
                        this.textShow = true;
                    });

            } else if (this.$route.query.name.includes('pdf')) {
                this.pdfShow = true;
                setTimeout(() => {
                    new Pdfh5("#PDFIframe2", {
                        pdfurl: this.$store.state.baseUrl + this.$route.query.item.fpath
                    });
                }, 300);
            } else if (this.$route.query.name.includes('mp4')) {
                this.videoUrl = this.$store.state.baseUrl + this.$route.query.item.fpath;
                this.videoShow = true;
            } else if (this.$route.query.name.includes('dwg')) {
                this.viewers(this.$store.state.baseUrl + this.$route.query.item.fchangepath)
                this.ViewShow = true;
            } else {
                Office2Pdf({ sourcePath: this.$route.query.item.fpath }).then((res) => {
                    if (res.Code === 0) {
                        this.$Toast.fail(res.Message);
                    } else {
                        this.pdfShow = true;
                        setTimeout(() => {
                            new Pdfh5("#PDFIframe2", {
                                pdfurl: this.$store.state.baseUrl + res.Data
                            });
                        }, 300);
                    }
                });
            }

        },
        handClickIMG() {
            ImagePreview({
                images: [this.imgUrl]
            })
        },
        viewers(url) {
            var _this = this;
            //初始化
            var config = {
                extensions: [
                    "Autodesk.Viewing.ZoomWindow",
                    // "Autodesk.Viewing.Collaboration",
                ],
                disabledExtensions: {
                    measure: false,
                    section: false,
                },
                memory: {
                    limit: 32 * 1024, //32 GB
                },
            };
            var myViewerDiv = document.getElementById("MyViewerDiv");
            _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
                myViewerDiv,
                config
            );
            var options = {
                document: url,
                language: "zh-HANS",
                env: "Local",
                offline: "true",
                useADP: false,
            };
            Autodesk.Viewing.Initializer(options, function onInitialized() {
                _this.viewer.start();
                _this.viewer.loadModel(options.document, {
                    isAEC: true,
                });
                _this.viewer.setTheme("light-theme");
                _this.viewer.addEventListener(
                    Autodesk.Viewing.TEXTURES_LOADED_EVENT,
                    function (event) {
                        //选择集
                        var json = Params.state.replace(/'/g, '"');
                        var jsonObject = JSON.parse(json);
                        _this.viewer.restoreState(jsonObject);
                    }
                );
            });
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        // 获取反馈权限
        async GetYWProUserAuthUser_new(type) {
            let params = {
                xid: this.$store.state.pid,
                type,
            };
            let res = await GetYWProUserAuth({ params })
            return res.Data
        },
        async goQuestion() {
            let auth = await this.GetYWProUserAuthUser_new(this.info.type)
            if (auth && auth.replyusers.length > 0) {
                switch (this.info.item.type) {
                    case 1:
                        this.type = 0
                        break;
                    case 2:
                        this.type = 1
                        break;
                    case 3:
                        this.type = 2
                        break;
                    case 4:
                        this.type = 4
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: "questionData", query: { name: this.$route.query.name, info: this.info.item, type: this.type, replyUser: this.$route.query.replyUser },
                });
            } else {
                this.$Notify({ type: "warning", message: "请联系管理员设置指定回复人！" });
                return;
            }

        }
    },
    mounted() {
        this.pathUrl()
        this.questionShow = this.$route.query.show;
        this.info = this.$route.query;
    },
}
</script>
<style lang="scss" scoped>
.fileinfo {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    background-color: #f5f5f5;

    .questionClass {
        position: absolute;
        z-index: 99999;
        bottom: 40%;
        right: 5%;
        width: 150px;
        border-radius: 40px;
        background: rgba(79, 112, 245, 1);
        display: flex;
        flex-direction: column;
        align-items: center
    }



    // .head {
    //     height: 6%;
    //     width: 50%;
    //     background: gray;
    //     position: relative;
    //     top: -10px;
    //     z-index: 99;
    // }
}

#MyViewerDiv {
    height: 95vh;
    width: 100%;
    position: absolute;
}

/deep/.viewerContainer .pinch-zoom-container {
    height: 100vh !important;
}

// /deep/.PDFIframe img {
//     height: 100vh !important;
// }</style>
